<template>
  <v-card
    max-width="100%"
    max-height="346px"
    elevation="0"
    class="mx-0 mt-3 scroll-vertical"
  >
    <v-data-table
      :headers="headers"
      :items="users"
      :items-per-page="5"
      class="elevation-1"
    >
      <!-- Customizing the DataTable with avatar -->
      <template v-slot:[`item.avatar`]="{ item }">
        <v-avatar color="primary_whiten" size="38" class="avatar-style">
          <span class="white--text headline">{{ item.avatar }}</span>
        </v-avatar>
      </template>
    </v-data-table>
  </v-card>
</template>
<script>
import { mapFields } from "vuex-map-fields";
export default {
  name: "RegisteredUsers",
  computed: {
    ...mapFields("donation", ["donationCenterItems"]),
  },
  data: () => ({
    headers: [
      {
        text: "Avatar",
        align: "start",
        sortable: false,
        value: "avatar",
      },
      {
        text: "Name",
        align: "start",
        sortable: false,
        value: "name",
      },
      { text: "Phone", value: "phone" },
      { text: "Country", sortable: false, value: "country" },
      { text: "City", value: "city" },
      { text: "Description", value: "description" },
    ],
    users: [],
  }),
  watch: {
    donationCenterItems: {
      immediate: true,
      handler(value) {
        if (value) {
          value.map((item) => { 
            this.users.push({
              avatar: "BT",
              description: item.content.description,
              name: item.content.fullName,
              phone: item.content.phoneNumber,
              city: "Addis Ababa",
              country: "Ethiopia",
            });
          }); 
        }
      },
    },
  },
};
</script>